import { render } from "./LinkBlock.vue?vue&type=template&id=35176f80&scoped=true"
import script from "./LinkBlock.vue?vue&type=script&lang=js"
export * from "./LinkBlock.vue?vue&type=script&lang=js"

import "./LinkBlock.vue?vue&type=style&index=0&id=35176f80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35176f80"]])

export default __exports__